import { render } from "./GlobalLoader.vue?vue&type=template&id=d87572a4"
import script from "./GlobalLoader.vue?vue&type=script&lang=js"
export * from "./GlobalLoader.vue?vue&type=script&lang=js"

import "./GlobalLoader.vue?vue&type=style&index=0&id=d87572a4&lang=css"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__